<topo-modal
  [isActive]="isActive"
  [backgroundCanClose]="true"
  (close)="close()"
  [isCard]="true">
  <div class="modal-header">
    <div
      class="mt-4 ml-4 mb-4"
      fxLayout="row"
      fxLayoutAlign="space-between">
      <h5>{{ 'MANAGEMENT.DATASETS.TRANSLATIONS' | translate }}</h5>
      <div>
        <div
          class="dialog-close"
          (click)="close()">
          <i class="icon icon-close-X"></i>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-body">
    <div class="language-section">
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        [ngClass]="{ 'language-selection': actions?.length > 10 }">
        <div
          class="select is-medium"
          style="width: 50%; margin-right: 2px">
          <label>{{ 'MANAGEMENT.DATASETS.SOURCE-LANGUAGES' | translate }}</label>
          <select
            [(ngModel)]="sourceCulture"
            (change)="sourceCultureSelected($event)">
            @for (lang of sourceLanguages; track lang) {
              <option
                [ngValue]="lang.cultureCode">
                {{ getLanguageDisplay(lang) }}
              </option>
            }
          </select>
        </div>
        <button
          title="{{ 'MANAGEMENT.DATASETS.AUTO-TRANSLATE-ALL' | translate }}"
          class="button is-small is-ghost mt-5"
          (click)="autoTranslateAll()">
          <i class="icon icon-globe"></i>
          <i class="icon icon-arrow2_right"></i>
        </button>
        <div
          class="select is-medium"
          style="width: 50%; margin-left: 2px">
          <label>{{ 'MANAGEMENT.DATASETS.TARGET-LANGUAGES' | translate }}</label>
          <select
            [(ngModel)]="targetCulture"
            (change)="targetCultureSelected($event)">
            @for (lang of targetLanguages; track lang) {
              <option
                [ngValue]="lang.cultureCode">
                {{ getLanguageDisplay(lang) }}
              </option>
            }
          </select>
        </div>
      </div>
    </div>
    @if (!!actions && actions.length) {
      <div
        class="fields-body"
        [ngClass]="{ 'fields-section': actions?.length > 10 }">
        @for (action of actions; track action.uId) {
          <div>
            <div
              fxLayout="row"
              fxLayoutAlign="center center"
              class="mb-1">
              <div style="width: 50%; margin-right: 2px">
                <input
                  readonly
                  class="input is-medium is-fullwidth"
                  type="text"
                  [(ngModel)]="sourceValues[action.uId]" />
              </div>
              <button
                title="{{ 'MANAGEMENT.DATASETS.AUTO-TRANSLATE' | translate }}"
                class="button is-small is-ghost"
                (click)="autoTranslateField(action)">
                <i class="icon icon-globe"></i>
                <i class="icon icon-arrow2_right"></i>
              </button>
              <div style="width: 50%; margin-left: 2px">
                <input
                  (change)="fieldChanged($event, action)"
                  class="input is-medium is-fullwidth"
                  type="text"
                  [(ngModel)]="targetValues[action.uId]" />
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>

  <div class="modal-footer">
    <div
      fxLayout="row"
      fxLayoutAlign="end"
      class="mt-4 mb-4">
      <div style="margin-right: 5px">
        <button
          class="button is-secondary"
          (click)="cancelClick()">
          {{ 'MANAGEMENT.DATAFEEDS.CANCEL' | translate }}
        </button>
      </div>
      <div>
        <button
          class="button is-primary"
          (click)="saveClick()">
          {{ 'MANAGEMENT.DATAFEEDS.SAVE' | translate }}
        </button>
      </div>
    </div>
  </div>
</topo-modal>
